var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 17,
    viewBox: "0 0 33 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.055 9.218H1.25V7.61h27.805l-5.06-5.06 1.138-1.136 7 7-7 7-1.137-1.137 5.059-5.06z",
    fill: "#D2AD81",
    stroke: "#D2AD81"
  })));
}
export default __webpack_public_path__ + "media/creativeMedia/rightArrow-0cfae2be.svg";
export { SvgRightArrow as ReactComponent };